export const servicesData = [
  {
    id: "deaddiction",
    slug: "deaddiction",
    title: "Deaddiction Treatment",
    tag: "Addiction Recovery",
    badge: "Medical Detox & Recovery",
    shortDescription: "Comprehensive support for individuals affected by alcohol, tobacco, drug, and behavioural addictions, with a structured clinical approach focused on recovery, stability, and rehabilitation.",
    image: "https://images.unsplash.com/photo-1527613426441-4da17471b66d?auto=format&fit=crop&w=1200&q=80",
    conditions: [
      "Alcohol Addiction",
      "Tobacco Addiction",
      "Cigarette Smoking",
      "Drug Addiction",
      "Mobile Addiction",
      "Opium Addiction",
      "Cannabis Addiction"
    ],
    whoItSupports: [
      "Individuals experiencing alcohol dependency and chronic alcohol misuse",
      "Persons seeking structured support to overcome tobacco and smoking addiction",
      "Individuals navigating narcotic, drug, opium, or cannabis dependency",
      "Adolescents and adults struggling with compulsive mobile and digital addiction",
      "Families seeking compassionate, medically supervised deaddiction pathways"
    ],
    overview: "Addiction is a complex, treatable health condition requiring structured medical and psychological care. UMED's Deaddiction Centre provides medically monitored detoxification, psychological relapse prevention, and comprehensive behavioral therapies to foster lasting sobriety and healthy habits.",
    approach: [
      {
        title: "Medically Monitored Detoxification",
        description: "24/7 clinical oversight to manage withdrawal symptoms safely, comfortably, and under strict medical protocols."
      },
      {
        title: "Addiction Counselling & Behavioral Therapy",
        description: "Specialized Alcoholic REBT, Cognitive Behavioural Therapy, and motivational sessions to address root psychological triggers."
      },
      {
        title: "Relapse Prevention & Trigger Management",
        description: "Developing practical refusal skills, emotional coping strategies, and structured lifestyle routines."
      },
      {
        title: "Continuous Rehabilitation & Family Support",
        description: "Incorporating family psychoeducation and ongoing aftercare to sustain long-term sobriety."
      }
    ],
    modules: [
      "Alcohol & Tobacco Deaddiction Programs",
      "Opium & Cannabis Substance Detox",
      "Digital & Mobile Addiction Interventions",
      "Alcoholic REBT & Relapse Prevention",
      "Family Psychoeducation & Recovery Support"
    ],
    ctaText: "Consult Deaddiction Specialist"
  },
  {
    id: "mental-health-care",
    slug: "mental-health-care",
    title: "Mental Health & Psychiatric Treatment",
    tag: "Clinical Psychiatry",
    badge: "24/7 Psychiatric Care",
    shortDescription: "Professional psychiatric care and ongoing support for a range of mental health conditions affecting mood, thoughts, behaviour, and daily functioning.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=1200&q=80",
    conditions: [
      "Schizophrenia",
      "Bipolar Mood Disorder",
      "Psychosis",
      "Sleep Disorder",
      "Anxiety",
      "Depression",
      "Stress Management"
    ],
    whoItSupports: [
      "Individuals experiencing severe depression, mood instability, or loss of interest",
      "Patients managing Bipolar Mood Disorder and cyclical affective episodes",
      "Persons experiencing acute or chronic psychosis and Schizophrenia",
      "Individuals dealing with chronic anxiety, panic episodes, or sleep disruptions",
      "Professionals and individuals facing severe emotional stress and burnout"
    ],
    overview: "UMED provides comprehensive psychiatric evaluations, crisis stabilization, and evidence-based clinical treatments for acute and chronic psychiatric conditions. Our consultant psychiatrists and clinical team ensure compassionate, continuous care.",
    approach: [
      {
        title: "Thorough Diagnostic Assessment",
        description: "In-depth clinical psychiatric evaluation and psychometric screening to establish an accurate treatment plan."
      },
      {
        title: "Individualized Pharmacotherapy",
        description: "Carefully calibrated psychiatric medications monitored closely to manage symptoms with high safety."
      },
      {
        title: "Cognitive & Supportive Interventions",
        description: "Integrating psychotherapy to rebuild emotional regulation, sleep cycles, and daily functioning."
      },
      {
        title: "24/7 Clinical Oversight",
        description: "Continuous medical and psychiatric nursing presence ensuring patient safety and peace of mind."
      }
    ],
    modules: [
      "Schizophrenia & Psychosis Management",
      "Bipolar Mood Disorder Stabilization",
      "Depression & Anxiety Care Pathways",
      "Sleep Architecture Restoration",
      "Clinical Stress Reduction Strategies"
    ],
    ctaText: "Consult Our Psychiatric Team"
  },
  {
    id: "intellectual-disability",
    slug: "intellectual-disability",
    title: "Intellectual Disability Care",
    tag: "Specialized Support",
    badge: "Long-Term Care & Support",
    shortDescription: "Compassionate, structured clinical care and continuous long-term support for individuals with intellectual disabilities to foster daily living skills and dignity.",
    image: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?auto=format&fit=crop&w=1200&q=80",
    conditions: [
      "Treatment & Care for Intellectual Disability",
      "Long-Term Residential Support",
      "Daily Living Skill Development",
      "Behavioural Adaptation Support",
      "Care With or Without Relatives' Assistance"
    ],
    whoItSupports: [
      "Individuals diagnosed with intellectual disabilities needing structured care",
      "Families seeking dependable long-term residential and clinical support",
      "Patients requiring assistance with daily routines and hygiene management",
      "Caregivers looking for compassionate, dignified, and safe living environments"
    ],
    overview: "UMED provides dedicated long-term care and supportive clinical assistance for individuals with intellectual disabilities. Our compassionate team focuses on enhancing adaptive skills, providing emotional safety, and maintaining a structured, warm daily routine.",
    approach: [
      {
        title: "Individualized Care Planning",
        description: "Customized daily routines that respect each individual's developmental level and strengths."
      },
      {
        title: "Daily Skill & Activity Training",
        description: "Supporting basic self-care, communication skills, and social interaction in a positive environment."
      },
      {
        title: "Continuous Nursing & Attendant Care",
        description: "Dedicated attendants, caretakers, and nurses assisting with meals, hygiene, and wellness."
      },
      {
        title: "Medical & Psychiatric Monitoring",
        description: "Regular health check-ups by physicians and psychiatrists to ensure holistic well-being."
      }
    ],
    modules: [
      "Long-Term Residential Care Facilities",
      "Structured Daily Routine Programs",
      "Attendant-Supported Personal Hygiene",
      "Social & Recreational Integration",
      "Regular Medical Health Reviews"
    ],
    ctaText: "Inquire About Disability Care"
  },
  {
    id: "brain-disorders",
    slug: "brain-disorders",
    title: "Brain Disorders & Cognitive Care",
    tag: "Neuropsychiatry",
    badge: "Neurocognitive Management",
    shortDescription: "Specialized clinical management and cognitive support for neurodegenerative conditions, memory disorders, and post-stroke behavioural challenges.",
    image: "https://images.unsplash.com/photo-1559757175-5700dde675bc?auto=format&fit=crop&w=1200&q=80",
    conditions: [
      "Alzheimer's Disease",
      "Dementia",
      "Post-Stroke Behavioural Problems",
      "Cognitive Impairment",
      "Memory & Focus Difficulties"
    ],
    whoItSupports: [
      "Elderly individuals living with Alzheimer's disease and progressive dementia",
      "Patients exhibiting behavioural changes, agitation, or confusion following a stroke",
      "Persons experiencing cognitive decline, disorientation, or memory loss",
      "Families needing safe, specialized care for memory-impaired loved ones"
    ],
    overview: "Neurocognitive and brain disorders require expert neuropsychiatric care and gentle, patient-centered handling. UMED offers structured environments that alleviate confusion, address agitation, and maintain cognitive engagement.",
    approach: [
      {
        title: "Neuropsychiatric Evaluation",
        description: "Detailed cognitive screening and behavioural assessment to understand the specific stage of impairment."
      },
      {
        title: "Behavioural & Pharmacological Management",
        description: "Safe medical interventions to manage sleep-wake disturbances, anxiety, and post-stroke behavioural changes."
      },
      {
        title: "Cognitive Stimulation & Orientation",
        description: "Gentle reality orientation, memory prompts, and structured cognitive exercises."
      },
      {
        title: "Safe, Supervised Environment",
        description: "Monitored campus facilities preventing wandering while preserving dignity and freedom."
      }
    ],
    modules: [
      "Dementia & Alzheimer's Care Protocol",
      "Post-Stroke Behavioural Stabilization",
      "Cognitive Retraining Exercises",
      "Geriatric Nursing & Physical Assistance",
      "Caregiver Guidance & Safety Planning"
    ],
    ctaText: "Consult Neurocognitive Team"
  },
  {
    id: "sexual-disorders",
    slug: "sexual-disorders",
    title: "Sexual Disorders & Psychosexual Health",
    tag: "Confidential Clinical Care",
    badge: "Specialized Medical Consultations",
    shortDescription: "Confidential clinical evaluation and medical management of psychosexual disorders, helping patients overcome anxiety, psychological barriers, and physiological concerns.",
    image: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?auto=format&fit=crop&w=1200&q=80",
    conditions: [
      "Erectile Dysfunction",
      "Premature Ejaculation",
      "Nightfall Concerns",
      "Reduced Libido & Desire Issues",
      "Performance Anxiety"
    ],
    whoItSupports: [
      "Men and individuals experiencing performance anxiety and psychosexual distress",
      "Patients dealing with reduced libido, intimacy issues, or physiological concerns",
      "Persons seeking scientifically accurate, stigma-free medical counsel",
      "Couples navigating intimacy challenges related to stress or mental health"
    ],
    overview: "Sexual health concerns often stem from a combination of psychological stress, performance anxiety, hormonal factors, and medical conditions. UMED provides discrete, non-judgmental consultations and evidence-based treatments.",
    approach: [
      {
        title: "Confidential Clinical Consultation",
        description: "Private, ethical, and compassionate medical assessment in a safe clinical atmosphere."
      },
      {
        title: "Biopsychosocial Evaluation",
        description: "Identifying underlying anxiety, depression, lifestyle factors, or physiological contributors."
      },
      {
        title: "Targeted Pharmacotherapy",
        description: "Medical treatments aligned with modern clinical guidelines to address physical aspects."
      },
      {
        title: "Psychosexual Counselling",
        description: "Cognitive strategies to eliminate performance stress and restore psychological confidence."
      }
    ],
    modules: [
      "Erectile Dysfunction Management",
      "Premature Ejaculation Therapy",
      "Performance Anxiety De-sensitization",
      "Libido & Intimacy Restoration",
      "Confidential One-on-One Consultations"
    ],
    ctaText: "Book Confidential Consultation"
  },
  {
    id: "counselling",
    slug: "counselling-therapy",
    title: "Counselling Services",
    tag: "Psychological Support",
    badge: "Empathetic Guidance",
    shortDescription: "Dedicated one-on-one and group counselling sessions providing empathetic listening, emotional processing, and constructive coping frameworks for life challenges.",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=1200&q=80",
    conditions: [
      "Individual Counselling",
      "Group Counselling",
      "Crisis Emotional Support",
      "Caregiver Support & Guidance",
      "Interpersonal Relationship Dynamics"
    ],
    whoItSupports: [
      "Individuals experiencing acute emotional distress, grief, or personal crises",
      "Patients needing a safe space to share feelings and explore life challenges",
      "Individuals benefiting from shared peer experiences in group settings",
      "Family members seeking clarity, guidance, and emotional coping tools"
    ],
    overview: "Professional counselling offers a safe, non-judgmental environment to navigate life stressors, emotional conflicts, and personal struggles. Our clinical psychologists and counsellors guide individuals toward self-awareness and emotional equilibrium.",
    approach: [
      {
        title: "Individual Counselling Sessions",
        description: "Focused personal sessions to explore unique thoughts, life challenges, and emotions."
      },
      {
        title: "Structured Group Counselling",
        description: "Facilitated group dialogues fostering peer connection, empathy, and collective strength."
      },
      {
        title: "Active Listening & Supportive Guidance",
        description: "Empowering individuals to discover practical solutions and emotional resilience."
      },
      {
        title: "Caregiver & Family Integration",
        description: "Guidance for family members to build supportive, healthy home communication."
      }
    ],
    modules: [
      "Personalized One-on-One Counselling",
      "Therapeutic Group Interaction Circles",
      "Grief & Emotional Processing",
      "Conflict Resolution & Communication",
      "Stress & Life Transition Guidance"
    ],
    ctaText: "Schedule a Counselling Session"
  },
  {
    id: "psychotherapy",
    slug: "psychotherapy",
    title: "Evidence-Based Psychotherapy",
    tag: "Clinical Psychology",
    badge: "Structured Therapeutic Modalities",
    shortDescription: "Structured, goal-oriented psychotherapeutic interventions to modify maladaptive cognitive patterns, address emotional triggers, and foster deep insight.",
    image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&w=1200&q=80",
    conditions: [
      "Cognitive Behavioural Therapy (CBT)",
      "Alcoholic REBT (Rational Emotive Behavior Therapy)",
      "Insight-Oriented Sessions",
      "Relapse Prevention Frameworks",
      "Emotional Regulation Training"
    ],
    whoItSupports: [
      "Individuals with unhelpful thought cycles, negative self-beliefs, or anxiety",
      "Patients recovering from alcohol dependency seeking cognitive restructuring",
      "Persons desiring deeper understanding of past patterns and emotional triggers",
      "Individuals committed to sustainable behavioural and emotional growth"
    ],
    overview: "Psychotherapy at UMED combines scientifically validated modalities including Cognitive Behavioural Therapy (CBT), Alcoholic Rational Emotive Behavior Therapy (REBT), and insight-oriented interventions delivered by qualified clinical psychologists.",
    approach: [
      {
        title: "Cognitive Behavioural Therapy (CBT)",
        description: "Identifying and replacing cognitive distortions with adaptive, realistic thinking patterns."
      },
      {
        title: "Alcoholic REBT Protocols",
        description: "Challenging irrational beliefs surrounding substance use and building emotional tolerance."
      },
      {
        title: "Insight-Oriented Exploration",
        description: "Uncovering deep-rooted emotional dynamics to foster long-term psychological maturity."
      },
      {
        title: "Skill Building & Homework Exercises",
        description: "Practical behavioral tools and self-monitoring exercises for daily real-world application."
      }
    ],
    modules: [
      "CBT for Anxiety & Depression",
      "Specialized Alcoholic REBT Modules",
      "Insight & Self-Discovery Sessions",
      "Mindfulness & Distress Tolerance",
      "Personalized Coping Toolkit Development"
    ],
    ctaText: "Begin Psychotherapy"
  },
  {
    id: "specialized-therapies",
    slug: "specialized-therapies",
    title: "Specialized Biological Therapies",
    tag: "Advanced Psychiatric Care",
    badge: "Clinical Biological Interventions",
    shortDescription: "Advanced psychiatric intervention modalities administered under strict medical supervision and international clinical safety standards for treatment-resistant conditions.",
    image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=1200&q=80",
    conditions: [
      "Electroconvulsive Therapy (ECT)",
      "Cerebral Stimulation Therapy",
      "Treatment-Resistant Depression Care",
      "Severe Mood Disorder Interventions",
      "Controlled Clinical Monitoring"
    ],
    whoItSupports: [
      "Patients with severe, medication-resistant depression or acute mood episodes",
      "Individuals experiencing catatonic states or urgent psychiatric conditions",
      "Patients requiring advanced biological treatments under expert monitoring",
      "Families seeking evidence-based specialized tertiary psychiatric care"
    ],
    overview: "For severe or treatment-resistant psychiatric conditions, UMED offers specialized biological modalities including Electroconvulsive Therapy (ECT) and Cerebral Stimulation Therapy, conducted with modern anaesthesia protocols and continuous clinical monitoring.",
    approach: [
      {
        title: "Rigorous Pre-Procedure Medical Evaluation",
        description: "Comprehensive cardiovascular, neurological, and anaesthetic clearance prior to any therapy."
      },
      {
        title: "State-of-the-Art Safety Protocols",
        description: "Administered in dedicated clinical suites with full monitoring and resuscitation support."
      },
      {
        title: "Consultant Psychiatrist Oversight",
        description: "Direct procedural administration and supervision by experienced senior psychiatric faculty."
      },
      {
        title: "Post-Procedure Recovery Care",
        description: "Close observation in recovery suites by trained psychiatric nurses ensuring patient comfort."
      }
    ],
    modules: [
      "Modified Electroconvulsive Therapy (ECT)",
      "Cerebral Stimulation Protocols",
      "Treatment-Resistant Clinical Pathways",
      "Comprehensive Pre & Post Monitoring",
      "Anaesthetic-Supported Safety Suites"
    ],
    ctaText: "Consult Clinical Specialist"
  },
  {
    id: "medical-support",
    slug: "medical-support",
    title: "Medical Support & Pharmacotherapy",
    tag: "Medical Management",
    badge: "24/7 Clinical Care",
    shortDescription: "Continuous medical oversight, expert pharmacotherapy management, and biological support to ensure patient safety and optimal physiological stabilization.",
    image: "https://images.unsplash.com/photo-1584515979956-d9f6e5d09982?auto=format&fit=crop&w=1200&q=80",
    conditions: [
      "Medication Management",
      "Injectable Medication Support",
      "IV Supplementation",
      "Vitals & Physical Health Monitoring",
      "Physician & Nursing Vigilance"
    ],
    whoItSupports: [
      "Inpatients requiring precise psychiatric medication titration and monitoring",
      "Patients experiencing nutritional deficits or dehydration needing IV support",
      "Individuals requiring injectable medications under professional nursing supervision",
      "Patients with co-existing general medical conditions (hypertension, diabetes, etc.)"
    ],
    overview: "Sound physical health is foundational to mental stability. UMED's medical support team ensures meticulous medication management, injectable administrations, intravenous hydration and nutrient supplementation, and 24/7 vital sign tracking.",
    approach: [
      {
        title: "Daily Medication Review",
        description: "Physicians and psychiatrists closely review medication dosages to ensure efficacy and minimize side effects."
      },
      {
        title: "Professional Injectable Administration",
        description: "Administering long-acting injectable antipsychotics or emergency medications with utmost sterile technique."
      },
      {
        title: "IV Hydration & Nutritional Supplementation",
        description: "Correcting electrolyte imbalances and nutritional depletion common during acute illness or detox."
      },
      {
        title: "Multispecialty Physician Support",
        description: "General physicians and medical officers managing overall physical health parameters."
      }
    ],
    modules: [
      "Daily Pharmacotherapy Titration",
      "Sterile Injectable Administration",
      "Intravenous Electrolyte & Vitamin Therapy",
      "24/7 Vitals & Health Parameter Logging",
      "General Medical Physician Consults"
    ],
    ctaText: "Inquire About Medical Support"
  },
  {
    id: "rehabilitation-wellness",
    slug: "psychiatric-rehabilitation",
    title: "Rehabilitation & Holistic Wellness",
    tag: "Holistic Wellness",
    badge: "Physical & Mental Rejuvenation",
    shortDescription: "Holistic daily routines incorporating mindful movement, exercise, and restorative recreation to rebuild physical vitality, emotional harmony, and lifestyle discipline.",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&w=1200&q=80",
    conditions: [
      "Yoga & Pranayama",
      "Warm-up & Stretching Exercises",
      "Daily Walking & Running",
      "Recreational Group Activities",
      "Lifestyle & Routine Restoration"
    ],
    whoItSupports: [
      "Patients in recovery rebuilding physical stamina, routine, and sleep balance",
      "Individuals seeking stress relief through somatic and breathing practices",
      "Persons transitioning from acute illness into active, purposeful daily life",
      "Individuals benefiting from team recreation, group games, and mindful habits"
    ],
    overview: "Healing encompasses the whole person. UMED integrates daily physical exercise, yoga, pranayama breathing, walking, and engaging recreational activities into patient routines to promote endorphin release, mental clarity, and somatic wellness.",
    approach: [
      {
        title: "Daily Guided Yoga & Pranayama",
        description: "Calming morning breathing techniques and restorative yoga postures to regulate the nervous system."
      },
      {
        title: "Structured Exercise & Warm-ups",
        description: "Guided warm-ups, stretching, walking, and running to restore cardiovascular vitality and energy."
      },
      {
        title: "Recreational & Team Activities",
        description: "Supervised recreational group games fostering social connection, joy, and positive dopamine release."
      },
      {
        title: "Circadian Rhythm Re-alignment",
        description: "Promoting natural sleep-wake cycles through sunlight exposure and healthy activity rhythms."
      }
    ],
    modules: [
      "Morning Yoga & Guided Pranayama",
      "Daily Fitness & Walking Sessions",
      "Supervised Recreation & Group Sports",
      "Somatic Relaxation & Mindfulness",
      "Circadian & Lifestyle Habit Training"
    ],
    ctaText: "Explore Wellness Programs"
  }
];
